import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';

import './initializer/numeral';
import './initializer/posthog';
import './scss/application.scss';
import * as serviceWorker from './serviceWorker';
import App from './app';

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.register();
